import { Link } from 'react-router-dom';

export const COMPANY = {
  entityLine: 'CareGuard is an entity of Bryant Enterprises LLC',
  legalName: 'Bryant Enterprises LLC',
  address: '850 Dogwood Road Suite B200 #2060, Lawrenceville, Georgia 30044, United States',
  website: 'careguardapp.com',
  websiteUrl: 'https://www.careguardapp.com',
  email: 'support@careguardapp.com',
};

const CompanyFooter = () => (
  <footer className="company-footer" data-testid="company-footer">
    <p className="company-footer-entity" data-testid="footer-entity">{COMPANY.entityLine}.</p>
    <p data-testid="footer-address">{COMPANY.address}</p>
    <p>
      <a href={COMPANY.websiteUrl} data-testid="footer-website">{COMPANY.website}</a>
      {' · '}
      <a href={`mailto:${COMPANY.email}`} data-testid="footer-email">{COMPANY.email}</a>
      {' · '}
      <Link to="/privacy-policy" data-testid="footer-privacy-link">Privacy Policy</Link>
      {' · '}
      <Link to="/sms-terms" data-testid="footer-sms-terms-link">SMS Terms</Link>
    </p>
    <p className="company-footer-copy">© {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.</p>
  </footer>
);

export default CompanyFooter;
